import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { MatchesMediaQuery } from './matchesMediaQuery';

const kindQuery = (Component: React.ComponentType<any>) => {
  const KindInjecter = (props: any) => {
    const passthroughProps = _.omit(
      props,
      'kindQueries',
      'mediaQueries',
      'matchesMediaQuery'
    );

    return (
      <Component
        {...passthroughProps}
        kind={[props.kind, props.matchesMediaQuery]}
      />
    );
  };

  const MediaQueryInverter = (props: any) => {
    const queryByKind = _.invert(props.kindQueries);

    const passthroughProps: Omit<typeof props, 'kindQueries'> = _.omit(
      props,
      'kindQueries'
    );

    return (
      <MatchesMediaQuery
        Component={KindInjecter}
        mediaQueries={queryByKind}
        {...passthroughProps}
      />
    );
  };

  MediaQueryInverter.propTypes = {
    // Key is media query, value is string `kind`.
    // Multiple kinds can also be passed space-separated e.g.: `kind1 kind2 kind3`
    kindQueries: PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string]).isRequired
    ),
  };
  MediaQueryInverter.defaultProps = {
    kindQueries: {},
  };
  return MediaQueryInverter;
};

export default kindQuery;
